import { initReactI18next } from "react-i18next";
import i18n from "i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        "create-new-institution-option": "Other",
        "new-institution-label": "Institution Name (in English)",
        "new-institution-placeholder": "Enter your Institution name",
        "new-institution-country-label": "Country (in English)",
        "new-institution-country-placeholder": "Select a country",
        "field-required-message": "This field is required",
        "first-name-field": "First name",
        "last-name-field": "Last name",
        "job-title-field": "Job title",
        "institution-name-field": "Institution Name (in English)",
        "create-button": "Create an Account",
        "email-field": "Email",
        "password-field": "Password",
        "stay-up-text":
          "Stay up to date on the latest Vitae news and employability.",
        "consent-text":
          "<p>By Creating an account, you agree to our <a href='/privacy'>Website Privacy Policy</a> and <a href='/terms-of-use'>Terms of Use</a><p>",
        "institution-placeholder": "Enter your Institution name",
        "password-validation-message": "Must be 6 or more characters.",
        "start-typing-message": "Start typing...",
        "no-options-message": "No options",
      },
    },
    es: {
      translation: {
        "create-new-institution-option": "Otros",
        "new-institution-label": "Nombre de la Institución (en inglés)",
        "new-institution-placeholder": "Ingrese su institución",
        "new-institution-country-label": "País (en inglés)",
        "new-institution-country-placeholder": "Seleccione un país",
        "field-required-message": "Este campo es obligatorio",
        "first-name-field": "Nombre de pila",
        "last-name-field": "Apellido",
        "job-title-field": "Título profesional",
        "institution-name-field": "Nombre de la Institución (en inglés)",
        "create-button": "Crear y comenzar",
        "email-field": "Correo electrónico",
        "password-field": "Clave",
        "stay-up-text":
          "Manténgase actualizado sobre las últimas noticias y empleabilidad de Vitae.",
        "consent-text":
          "<p>Al crear una cuenta, usted acepta nuestros <a href='/privacy'>Política de Privacidad del Sitio web</a> y <a href='/terms-of-use'>Términos de Uso</a><p>",
        "institution-placeholder": "Ingrese su institución",
        "password-validation-message": "Debe tener 6 caracteres o más.",
        "start-typing-message": "Empieza a escribir...",
        "no-options-message": "Sin opciones",
      },
    },
    ar: {
      translation: {
        "create-new-institution-option": "أخرى",
        "new-institution-label": "اسم المؤسسة (بالإنجليزية)",
        "new-institution-placeholder": "أدخل اسم مؤسستك",
        "new-institution-country-label": "البلد (بالإنجليزية)",
        "new-institution-country-placeholder": "اختر بلدًا",
        "field-required-message": "هذا الحقل مطلوب",
        "first-name-field": "الاسم الأول",
        "last-name-field": "اسم العائلة",
        "job-title-field": "المسمى الوظيفي",
        "institution-name-field": "اسم المؤسسة (بالإنجليزية)",
        "create-button": "إنشاء حساب",
        "email-field": "البريد الإلكتروني",
        "password-field": "كلمة المرور",
        "stay-up-text":
          "ابقَ على اطلاع بآخر أخبار فيتاي وفرص التوظيف.",
        "consent-text":
          "<p>من خلال إنشاء حساب، فإنك توافق على <a href='/privacy'>سياسة خصوصية الموقع</a> و <a href='/terms-of-use'>شروط الاستخدام</a><p>",
        "institution-placeholder": "أدخل اسم مؤسستك",
        "password-validation-message": "يجب أن تكون 6 أحرف أو أكثر.",
        "start-typing-message": "ابدأ الكتابة...",
        "no-options-message": "لا توجد خيارات",
      },
    },
    fr: {
      translation: {
        "create-new-institution-option": "Autre",
        "new-institution-label": "Nom de l'établissement (en anglais)",
        "new-institution-placeholder": "Entrez le nom de votre établissement",
        "new-institution-country-label": "Pays (en anglais)",
        "new-institution-country-placeholder": "Sélectionnez un pays",
        "field-required-message": "Ce champ est requis",
        "first-name-field": "Prénom",
        "last-name-field": "Nom",
        "job-title-field": "Intitulé du poste",
        "institution-name-field": "Nom de l'établissement (en anglais)",
        "create-button": "Créer un compte",
        "email-field": "E-mail",
        "password-field": "Mot de passe",
        "stay-up-text":
          "Restez informé des dernières nouvelles et opportunités de Vitae.",
        "consent-text":
          "<p>En créant un compte, vous acceptez notre <a href='/privacy'>Politique de confidentialité</a> et nos <a href='/terms-of-use'>Conditions d’utilisation</a><p>",
        "institution-placeholder": "Entrez le nom de votre établissement",
        "password-validation-message": "Doit contenir 6 caractères ou plus.",
        "start-typing-message": "Commencez à taper...",
        "no-options-message": "Aucune option",
      },
    },
    pt: {
      translation: {
        "create-new-institution-option": "Outro",
        "new-institution-label": "Nome da Instituição (em inglês)",
        "new-institution-placeholder": "Introduza o nome da sua Instituição",
        "new-institution-country-label": "País (em inglês)",
        "new-institution-country-placeholder": "Selecione um país",
        "field-required-message": "Este campo é obrigatório",
        "first-name-field": "Primeiro nome",
        "last-name-field": "Apelido",
        "job-title-field": "Cargo",
        "institution-name-field": "Nome da Instituição (em inglês)",
        "create-button": "Criar Conta",
        "email-field": "Email",
        "password-field": "Palavra-passe",
        "stay-up-text":
          "Mantenha-se atualizado com as últimas notícias e práticas de empregabilidade da Vitae.",
        "consent-text":
          "<p>Ao criar uma conta, concorda com a nossa <a href='/privacy'>Política de Privacidade</a> e com os <a href='/terms-of-use'>Termos de Utilização</a><p>",
        "institution-placeholder": "Introduza o nome da sua Instituição",
        "password-validation-message": "Deve ter 6 ou mais caracteres.",
        "start-typing-message": "Comece a escrever...",
        "no-options-message": "Sem opções",
      },
    },
  },
  lng: "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
